import { setRangeMax, setRangeMin } from './helpers';

export const setMinWorkplaceCount = setRangeMin('workplace_count');

export const setMaxWorkplaceCount = setRangeMax('workplace_count');
